import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const menuDesktop = '111px';
const menuMobile = '81px';

export const StyledWrapper = styled.div`
  position: fixed;
  top: ${menuMobile};
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  z-index: 4000;
  visibility: hidden;
  overflow: auto;
  opacity: 0;
  background: rgba(0, 0, 0, 0.58);
  display: flex;
  justify-content: var(--menu-position, flex-end);

  ${({ isVisible }) =>
    isVisible &&
    css`
      transition: 0.5s;
      opacity: 1;
      visibility: visible;
    `};

  ${({ isVisible }) =>
    !isVisible &&
    css`
      transition: 0.2s;
      opacity: 0;
      visibility: hidden;
    `};

  ${media.md`
    top: ${menuDesktop};
  `}
`;
